














































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { namespace } from 'vuex-class'

import Panel from '@/components/base/Panel.vue'
// import TablePage from "@/components/base/TablePage.vue";

const indexModule = namespace('index')
const couponModule = namespace('coupon')

@Component({
  components: {}
})
export default class CouponInfo extends Vue {
  @couponModule.State('infoId') couponId!: string
  @couponModule.State('infoName') infoName!: string
  @couponModule.State('infoStatus') infoStatus!: number
  @couponModule.State('infoStatusDesc') infoStatusDesc!: string
  @couponModule.State('infoMainInfo') infoMainInfo!: string
  @couponModule.State('infoExtendInfo') infoExtendInfo!: string
  @couponModule.State('infoFacePrice') infoFacePrice!: number
  @couponModule.State('infoUnitPrice') infoUnitPrice!: number
  @couponModule.State('infoDiscount') infoDiscount!: number
  @couponModule.State('couponDescClause') couponDescClause!: string
  @couponModule.State('infoCost') infoCost!: number
  @couponModule.State('infoCategoryId') infoCategoryId!: number
  @couponModule.State('infoCategoryIdDesc') infoCategoryIdDesc!: string
  @couponModule.State('infoActivityId') infoActivityId!: string
  @couponModule.State('infoActivityName') infoActivityName!: string
  @couponModule.State('infoQuantity') infoQuantity!: number
  @couponModule.State('infoGetQuantity') infoGetQuantity!: number
  @couponModule.State('infoEffectiveQuantity') infoEffectiveQuantity!: number
  @couponModule.State('infoDisplayDate') infoDisplayDate!: Array<string>
  @couponModule.State('infoGetDate') infoGetDate!: Array<string>
  @couponModule.State('infoGetWeeks') infoGetWeeks!: Array<string>
  @couponModule.State('infoGetTimes') infoGetTimes!: Array<string>
  @couponModule.State('infoEffectiveDate') infoEffectiveDate!: Array<string>
  @couponModule.State('infoEffectiveWeeks') infoEffectiveWeeks!: Array<string>
  @couponModule.State('infoEffectiveTimes') infoEffectiveTimes!: Array<string>
  @couponModule.State('infoEffectiveEntityType')
  infoEffectiveEntityType!: string
  @couponModule.State('infoEffectiveEntityList')
  infoEffectiveEntityList!: Array<string>
  @couponModule.State('infoTenantName') infoTenantName!: string
  @couponModule.State('infoDesc') infoDesc!: string
  @couponModule.State('infoPics') infoPics!: Array<string>
  @couponModule.State('infoHtml') infoHtml!: Array<string>
  @couponModule.State('infoEffectiveConditionLimit')
  infoEffectiveConditionLimit!: number
  @couponModule.State('infoDayLimit') infoDayLimit!: number
  @couponModule.State('infoTotalLimit') infoTotalLimit!: number
  @couponModule.State('infoWarningLimit') infoWarningLimit!: number
  @couponModule.State('infoEffectiveCategoryIdLimit')
  infoEffectiveCategoryIdLimit!: string
  @couponModule.State('infoPrecouponSwitch') infoPrecouponSwitch!: number

  @couponModule.State('list') list!: Array<any>

  @couponModule.Getter('CATEGORY_VALUE') CATEGORY_VALUE!: any
  @couponModule.Getter('STATUS_VALUE') STATUS_VALUE!: any

  infoTab: string = 'receive'

  inputEffectiveFilterPayload: any = {}
  defaultImg: any = require('@/image/default.png')
  mounted() {
    this.$store.commit('coupon/setCouponId', this.$route.params.id)
    this.getInfoHandler()
  }

  getInfoHandler() {
    this.$store.dispatch('coupon/getCouponInfo')
    // this.effectiveHandler();
  }

  // goCopyHandler() {
  //   this.$router.push(`/coupon/copy/${this.couponId}`);
  // }

  // discardHandler(couponId: number) {
  //   (this as any)
  //     .$confirm("您确定废弃当前优惠券吗?", "废弃优惠券")
  //     .then(async res => {
  //       if (res == "confirm") {
  //         const { error, success } = await this.$store.dispatch(
  //           "coupon/discardCoupon"
  //         );
  //         if (success) {
  //           (this as any).$alert(success.msg);
  //           this.getInfoHandler();
  //         }
  //       }
  //     })
  //     .catch(res => {});
  // }

  // offHandler(couponId: number) {
  //   (this as any)
  //     .$confirm("您确定暂停当前优惠券吗?", "暂停优惠券")
  //     .then(async res => {
  //       if (res == "confirm") {
  //         const { error, success } = await this.$store.dispatch(
  //           "coupon/offCoupon"
  //         );
  //         if (success) {
  //           (this as any).$alert(success.msg);
  //           this.getInfoHandler();
  //         }
  //       }
  //     })
  //     .catch(res => {});
  // }

  // onHandler(couponId: number) {
  //   (this as any)
  //     .$confirm("您确定启用当前优惠券吗?", "启用优惠券")
  //     .then(async res => {
  //       if (res == "confirm") {
  //         const { error, success } = await this.$store.dispatch(
  //           "coupon/onCoupon"
  //         );
  //         if (success) {
  //           (this as any).$alert(success.msg);
  //           this.getInfoHandler();
  //         }
  //       }
  //     })
  //     .catch(res => {});
  // }

  // goExportHandler() {
  //   this.$router.push("/coupon/export/info");
  // }

  effectiveHandler(payload: any = {}) {
    this.inputEffectiveFilterPayload = payload
    ;(this.$refs.table as any).reset()
  }

  pageHandler(pageNum: number, pageSize: number) {
    this.$store.dispatch('coupon/getCouponEntityList', {
      ...this.inputEffectiveFilterPayload,
      pageNum,
      pageSize
    })
  }
}
